export const home = {
  key: "home",
  path: "/",
  header: true,
};

export const portfolio = {
  key: "portfolio",
  path: "/portfolio",
  header: true,
};

export const project = {
  key: "project",
  path: "/portfolio/:slug",
  header: false,
};

export const contact = {
  key: "contact",
  path: "/contact",
  header: true,
};
